/*
  Geolocation
*/

class Geolocation {
  lat: number | null = null
  lng: number | null = null
  #watcherHandler: number | null = null
  #timestamp: number | null = null

  /** Starts watching the browser geolocation and dispatches position events. */
  start() {
    if (this.#watcherHandler) return

    this.#watcherHandler = navigator.geolocation.watchPosition(
      (position) => this.#success(position),
      (error) => this.#error(error)
    )
  }

  /** Stops the active browser geolocation watcher and clears cached freshness. */
  stop() {
    if (!this.#watcherHandler) return

    navigator.geolocation.clearWatch(this.#watcherHandler)
    this.#watcherHandler = null
    this.#timestamp = null
  }

  /** Restarts geolocation tracking from a clean watcher. */
  restart() {
    this.stop()
    this.start()
  }

  /** Returns true once a usable position has been received. */
  isAvailable() {
    return this.#timestamp != null
  }

  #success(position: GeolocationPosition) {
    this.lat = position.coords.latitude
    this.lng = position.coords.longitude

    if (this.#timestamp && position.timestamp - this.#timestamp < 900000)
      return

    this.#timestamp = position.timestamp
    this.#updatePosition()

    const event = new CustomEvent('position:updated', { detail: { lat: this.lat, lng: this.lng } })
    document.dispatchEvent(event)
  }

  #error(error: GeolocationPositionError) {
    if (error.code == error.PERMISSION_DENIED) {
      this.stop()
      document.dispatchEvent(new Event('position:denied'))
    } else if (!this.isAvailable()) {
      document.dispatchEvent(new Event('position:unavailable'))
    }
  }

  #updatePosition() {
    const csrfToken = document.querySelector<HTMLMetaElement>("[name='csrf-token']")!.content

    fetch('/update_position', {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ lat: this.lat, lng: this.lng })
    })
  }
}

export default new Geolocation()
